import React from 'react';
import { WixBaseUiEnvironmentProvider } from '@wix/wix-base-ui';
import { useExperiments } from '../..';
import { useSettingsEnvironment } from '../EnvironmentProvider';
import { getEditorType } from '../../helpers';
var specs = {
    editorXWithMadefor: 'specs.components.editorX.useMadefor',
    classicWithMadefor: 'specs.components.editorClassic.useMadefor',
};
// Use Helvetica everywhere, except for Editor 3 (unless 'useMadefor' experiments are enabled)
var shouldUseMadefor = function (experiments, environment, editorType) {
    if (editorType === 'EDITOR3') {
        return true;
    }
    if (!experiments) {
        return false;
    }
    var isWixStudio = environment.isWixStudio, isEditorX = environment.isEditorX;
    var useEditorXSpec = isWixStudio || isEditorX;
    return useEditorXSpec
        ? experiments.enabled(specs.editorXWithMadefor)
        : experiments.enabled(specs.classicWithMadefor);
};
var getEditorTheme = function (environment, editorType) {
    var isWixStudio = environment.isWixStudio, isEditorX = environment.isEditorX;
    if (isWixStudio || isEditorX) {
        return 'responsive';
    }
    switch (editorType) {
        case 'STUDIO':
            return 'responsive';
        case 'EDITOR3':
            return 'odeditor';
        default:
            return 'facelift';
    }
};
export var BaseUiEnvironmentProviderWrapper = function (_a) {
    var children = _a.children, experimentsConfig = _a.experimentsConfig;
    var useNoExperiments = function () { return null; };
    var useHook = experimentsConfig ? useExperiments : useNoExperiments;
    var experimentsContext = useHook();
    var environment = useSettingsEnvironment();
    var editorType = React.useMemo(getEditorType, []);
    var editorTheme = React.useMemo(function () { return getEditorTheme(environment, editorType); }, [environment, editorType]);
    return (React.createElement(WixBaseUiEnvironmentProvider, { madefor: shouldUseMadefor(experimentsContext === null || experimentsContext === void 0 ? void 0 : experimentsContext.experiments, environment, editorType), inputBorders: true, theme: editorTheme, dataHook: "base-ui-provider" }, children));
};
//# sourceMappingURL=index.js.map